import mqtt from "mqtt";
const { ops } = window.config;
let mqttConnect = {
  // 连接参数
  connection: {
    // host: mqttHost,
    // port: ops.port || "", //连接的端口
    endpoint: ops.endpoint || "", //根节点，可留空
    clean: true, // 保留会话
    topicName: null, // 保留会话
    keepalive: 10, //心跳
    /* Clean Session
         告诉代理客户端是否要建立持久会话。
         在持久会话 (CleanSession = false) 中，代理存储客户端的所有订阅以及以服务质量 (QoS)级别 1 或 2订阅的客户端的所有丢失消息。
         如果会话不是持久的 (CleanSession = true )，代理不为客户端存储任何内容，并清除任何先前持久会话中的所有信息
         */
    connectTimeout: 3000, // 超时时间
    reconnectPeriod: 1000, // 重连时间间隔
    // 认证信息
    clientId: ops.clientId, //id,同时多个连接去连一个服务，id要不同， mqtt服务器用来区分是那个客户端身份的唯一识别
    // username: ops.username, //用户名
    // password: ops.password, //密码
    status: {
      linkStatus: false, //连接状态
      reconnecting: false, //重连状态
      doSubscribeStatus: false, //订阅状态
      wsStatus: undefined,
      wsSessionId: undefined,
      wsBreakLinkNum: 0,
    },
    subscribeList: [],
    topic: '' // 主题
  },
  // 订阅信息
  subscription: {
    /**
     * 主题
     * 每个主题必须至少包含1 个字符，并且主题字符串允许有空格。主题区分大小写。
     * 例如，myhome/temperature和MyHome/ Temperature是两个不同的主题。此外，单独的正斜杠是一* 个有效的主题。
     *可用通配符：单级：+，多级：#
     */
    topic: "topic/mqttx",
    /**
     * QoS0，发送就不管了，最多一次； 
     * QoS1，发送之后依赖MQTT规范，是否启动重传消息，所以至少一次；
     * QoS2，发送之后依赖MQTT消息机制，确保只有一次
     */
    qos: 1,
    
  },
  // 发送参数
  publish: {
    topic: "topic/browser",
    qos: 1,
    payload: '{ "msg": "Hello, I am browser." }',
  },
  // 实例
  client: {
    connected: false,
  },
  getStatus () {
    return this.connection.status;
  },
  handleStatus(status) {
    if (!status.linkStatus) {
      return false
    }
    if (status.linkStatus) {
      if (!status.doSubscribeStatus) {
        return false
      }
    }
    this.getStatus(status);
  },
  // 创建连接
  async createConnection(cusPotios, callback) {
    try {
      // 连接字符串, 通过协议指定使用的连接方式
      // ws 未加密 WebSocket 连接
      // wss 加密 WebSocket 连接
      // mqtt 未加密 TCP 连接
      // mqtts 加密 TCP 连接
      // wxs 微信小程序连接
      // alis 支付宝小程序连接
      const { endpoint, ...options } = this.connection;
      if (cusPotios.username) {
        options.username = cusPotios.username;
      }
      if (cusPotios.password) {
        options.password = cusPotios.password;
      }
      if (cusPotios.host) {
        options.host = cusPotios.host || '';
      }
      const connectUrl = `${options.host}${endpoint}`
      this.connection.status.clientId = options.clientId;
      try {
        console.log(connectUrl, options, endpoint, 'connectUrlconnectUrlconnectUrl');
        this.client = mqtt.connect(connectUrl, options);
        this.client.setMaxListeners(20) // 设置监听阈值
      } catch (error) {
        console.error("连接发起报错，失败原因：", error);
        this.connection.status.wsStatus = "连接失败";
        this.connection.status.linkStatus = false;
        this.handleStatus(this.connection.status);
        callback(this.connection.status)
      }
      this.client.on("connect", () => {
        this.connection.status.wsStatus = "连接成功";
        this.connection.status.linkStatus = true;
        this.handleStatus(this.connection.status);
        callback(this.connection.status)
      });
      this.client.on("error", (error) => {
        console.error("连接失败，失败原因：", error);
        this.connection.status.wsStatus = "连接失败";
        this.connection.status.linkStatus = false;
        this.handleStatus(this.connection.status);
        callback(this.connection.status)
        // this.client.end()
      });
      // 重连
      this.client.on("reconnect", (error) => {
        console.error("重连失败，失败原因：", error);
        this.connection.status.wsBreakLinkNum++;
        this.connection.status.wsStatus = "正在重连";
        this.connection.status.linkStatus = false;
        this.connection.status.reconnecting = true;
        this.handleStatus(this.connection.status);
        callback(this.connection.status)
      });
      // 接收消息
    } catch (err) {
      console.error(err);
    }
  },
  async reconnect() {},
  //监听服务器是否连接失败
  async mqttError() {},
  // 订阅主题
  async doSubscribe(topic) {
    return new Promise((resolve, reject) => {
      topic = topic || this.connection.topic
      let indneTime = 0;
      const { qos } = this.subscription;
      this.client.subscribe(topic, { qos }, (error, res) => {
        if (error) {
          this.connection.status.doSubscribeStatus = false;
          this.connection.status.wsStatus = "订阅主题失败";
          this.handleStatus(this.connection.status);
          reject(error)
        } else {
          this.connection.topicName = topic;
          this.connection.status.wsStatus = "订阅主题成功";
          this.connection.status.doSubscribeStatus = true;
          this.connection.subscribeList.push(topic);
          this.handleStatus(this.connection.status);
          resolve()
        }
      })
    })
  },
  // 监听返回
  async clientMessage(callback) {
    this.client.on("message", (topic, message) => {
      message = message.toString();
      this.connection.status.wsStatus = "连接成功";
      this.handleStatus(this.connection.status);
      callback(topic, message)
    });
  },
  async mqStatus(callback) {
    callback(this.connection.status);
  },
  // 取消订阅
  async doUnSubscribe(topic) {
    if (!this.client.connected) {
      console.log("客户端未连接");
      return;
    }
    topic = topic || this.connection.topic
    if (!this.connection.subscribeList.includes(topic)) {
      return;
    }
    this.client.unsubscribe(topic, (error) => {
      if (error) {
        this.connection.status.wsStatus = "取消订阅失败";
        this.handleStatus(this.connection.status);
        return;
      }
      this.connection.status.wsStatus = "取消订阅成功";
      this.connection.status.doSubscribeStatus = false;
      this.handleStatus(this.connection.status);
      let index = this.connection.subscribeList.indexOf(topic);
      if (index) {
        this.connection.subscribeList.splice(index, 1);
      }
    });
  },
  // 发送消息
  async doPublish(topic, payload) {
    return new Promise((resolve, reject) => {
      if (!this.client.connected) {
        console.log("客户端未连接");
        return;
      }
      topic = topic || this.connection.topic
      const { qos } = this.publish;
      this.client.publish(topic, payload, qos, (error) => {
        if (error) {
          reject(err)
          console.log(topic, "发送失败", error);
        } else {
          resolve()
        }
      });
    })
  },
  // 断开连接
  async destroyConnection() {
    if (this.client.connected) {
      try {
        this.client.end();
        this.client = {
          connected: false,
        };
        this.connection.status.wsStatus = "成功断开连接";
        this.handleStatus(this.connection.status);
        console.log("成功断开");
      } catch (error) {
        this.connection.status.wsStatus = "连接断开失败";
        this.handleStatus(this.connection.status);
        console.log("断开失败", error.toString());
      }
    }
  }
};
export default mqttConnect;
